const API_CODE_TYPE = {
	SUCCESS: '200',
	NOT_LOGIN: '401',
}

export default API_CODE_TYPE